export enum WebUserEnum {
  Normal = 0,
  SiteUser = 1,
  SiteManager = 2,
  RegionalManager = 3,
  PrimaryCustomer = 4,
}

export const webUserMap: Record<number, string> = {
  [WebUserEnum.Normal]: 'Normal',
  [WebUserEnum.SiteUser]: 'SiteUser',
  [WebUserEnum.SiteManager]: 'Site Manager',
  [WebUserEnum.RegionalManager]: 'Regional Manager',
  [WebUserEnum.PrimaryCustomer]: 'Primary Customer',
};
